import * as R from "ramda";
import * as React from "react";

import { HintText } from "../../../../App/Common/Components/FormComponents";
import { ICourseAuthorResolvedData, ILocalizedMessageApi } from "../../../../reducers/course-author/types";
import { PreferredLocale } from "../../../../utils/locales";
import { ICourseEditOperations, IFullCourse } from "../../../course-author/types";
import CloneCourse from "./CloneCourse";
import DangerZone from "./DangerZone";
import EditorListing from "./EditorListing";
import MediaSettings from "./MediaSettings";
import SCORMExport from "./SCORMExport";
import SelectLocalizations from "./SelectLocalizations";
import CourseSetup from "./Setup";

export interface ISettingsTabProps {
  course: IFullCourse;
  courseId: string;
  currentLocale: PreferredLocale;
  editOperations: ICourseEditOperations;
  resolve: (key: keyof ICourseAuthorResolvedData, requestData: string[]) => void;
  resolvedData: ICourseAuthorResolvedData;
  userId: string;
  localizedMessageApi: ILocalizedMessageApi;
}

const settingsChangeMsg = "Please note that changes to these settings will only come into effect after publication.";

export default class SettingsTab extends React.Component<ISettingsTabProps> {
  public componentDidMount() {
    const { course, resolve, resolvedData } = this.props;
    const requestData = course.state.admins.map(userId => `${userId}?display`);
    const resolvedAdmins = resolvedData.admins.map(R.path([0]));

    if (!R.equals(requestData, resolvedAdmins)) {
      resolve("admins", requestData);
    }
  }

  public render() {
    const { course, courseId, currentLocale, editOperations, userId, resolvedData, localizedMessageApi } = this.props;
    return (
      <>
        <HintText>{settingsChangeMsg}</HintText>
        <CourseSetup
          course={course}
          currentLocale={currentLocale}
          editOperations={editOperations}
          localizedMessageApi={localizedMessageApi}
        />
        <CloneCourse editOperations={editOperations} course={course} userId={userId} />
        <SelectLocalizations course={course} courseId={courseId} editOperations={editOperations} userId={userId} />
        <EditorListing course={course} courseId={courseId} editors={resolvedData.admins} userId={userId} />
        <MediaSettings course={course} courseId={courseId} userId={userId} />
        <SCORMExport course={course} courseId={courseId} userId={userId} />
        <DangerZone
          course={course}
          courseId={courseId}
          deleteCourse={editOperations.deleteCourse}
          modifyOrganizationOwner={editOperations.modifyOrganizationOwner}
          toggleLockCourse={editOperations.toggleLockCourse}
        />
      </>
    );
  }
}
